import { Link } from '@tanstack/react-router'
import { CardContent } from '@saas-pages/shared/ui'
import { Seo } from '@saas-pages/shared/public/seo'
import branding from '../../../branding.config'
import { seoFor } from '@/seo/routes'
import { LocalizedProcessingBadge, useT } from '@/shared/i18n'
import { buildTools, type ToolDefinition } from '@/shared/tools/tools'

export function IndexPage() {
  const t = useT()
  const tools = buildTools(t).filter((tool) => tool.status === 'available')

  return (
    <>
      <Seo {...seoFor('index', t)} ogImage={branding.ogImage} />

      <div className="mx-auto max-w-6xl">
        <section className="max-w-3xl">
          <h1 className="text-2xl font-bold tracking-normal sm:text-4xl">{t.hero.title}</h1>
          <p className="mt-2 text-sm leading-6 text-muted-foreground sm:text-base">
            {t.hero.description}
          </p>
        </section>

        <section id="tools" className="mt-5 scroll-mt-4 sm:mt-8">
          <h2 className="sr-only">{t.catalog.title}</h2>
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {tools.map((tool) => (
              <ToolCard key={tool.key} tool={tool} />
            ))}
          </div>
        </section>
      </div>
    </>
  )
}

function ToolCard({ tool }: { tool: ToolDefinition }) {
  return (
    <Link
      to={tool.path}
      className="block rounded-lg border bg-card shadow-sm outline-none transition-colors hover:border-foreground/30 hover:bg-accent/45 focus-visible:ring-2 focus-visible:ring-ring"
    >
      <CardContent className="flex items-start gap-3 p-4">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border bg-background text-sm font-semibold">
          {tool.icon}
        </span>
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <h3 className="font-semibold tracking-normal">{tool.title}</h3>
            <LocalizedProcessingBadge variant={tool.processing} />
          </div>
          <p className="mt-1 text-sm leading-5 text-muted-foreground">{tool.shortDescription}</p>
        </div>
      </CardContent>
    </Link>
  )
}
